/**
 * Utility functions for formatting display values
 */

/**
 * Formats a jersey number by removing decimal points (e.g., "11.0" -> "11")
 * Also strips any non-alphanumeric characters for display
 * @param {string|number} jerseyNumber - The jersey number to format
 * @returns {string} Formatted jersey number
 */
export const formatJerseyNumber = (jerseyNumber) => {
  if (!jerseyNumber && jerseyNumber !== 0) return '';
  
  let str = String(jerseyNumber);
  
  // Remove trailing .0 from numbers like "11.0"
  if (str.endsWith('.0')) {
    str = str.slice(0, -2);
  }
  
  // Also handle any other decimal values by taking only the integer part
  if (str.includes('.')) {
    str = str.split('.')[0];
  }
  
  return str.trim();
};

/**
 * Sanitizes jersey number input to only allow alphanumeric characters (no decimals/periods)
 * @param {string} value - The input value to sanitize
 * @param {number} maxLength - Maximum allowed length (default 5)
 * @returns {string} Sanitized jersey number
 */
export const sanitizeJerseyNumber = (value, maxLength = 5) => {
  if (!value) return '';
  // Remove any non-alphanumeric characters (including periods/decimals)
  return value.replace(/[^a-zA-Z0-9]/g, '').slice(0, maxLength);
};
